import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ToastSeverity = 'error' | 'warning' | 'info' | 'success';

export interface ToastState {
  open: boolean;
  message: string;
  severity: ToastSeverity;
  // Label for an optional action button. The handler itself lives in the
  // (non-serializable) registry in utils/toast.ts, keyed by actionId.
  actionLabel?: string;
  actionId?: string;
  // null = stay open until the user dismisses/acts (used when there's an action).
  autoHideMs: number | null;
}

const initialState: ToastState = {
  open: false,
  message: '',
  severity: 'info',
  actionLabel: undefined,
  actionId: undefined,
  autoHideMs: 6000,
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast(state, action: PayloadAction<Omit<ToastState, 'open'>>) {
      return { ...action.payload, open: true };
    },
    hideToast(state) {
      state.open = false;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
